import { createSvgIcon } from "@mui/material/utils";

export const CompleteCircle = createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <g clip-path="url(#clip0_974_10523)">
            <path
                d="M18.2699 9.20106V9.96466C18.2689 11.7545 17.6893 13.496 16.6177 14.9296C15.546 16.3631 14.0396 17.4118 12.3233 17.9193C10.6069 18.4268 8.77245 18.3658 7.09353 17.7456C5.41462 17.1253 3.98119 15.9789 3.00702 14.4774C2.03285 12.9759 1.57015 11.1998 1.68791 9.4138C1.80568 7.62785 2.4976 5.92781 3.66049 4.56723C4.82338 3.20665 6.39493 2.25843 8.14076 1.86398C9.88658 1.46954 11.7131 1.65 13.348 2.37846M18.2699 3.31991L9.96992 11.6282L7.47992 9.13821"
                stroke="#099250"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_974_10523">
                <rect
                    width="19.92"
                    height="19.92"
                    fill="white"
                    transform="translate(0.00976562)"
                />
            </clipPath>
        </defs>
    </svg>,
    "CompleteCircle"
);
